export const getLoggedInUser = `
query MyQuery($id: ID!) {
  getUsers(id: $id) {
    id
    email
    country
    contactPersonUserId
    companyContactPersonUserId
    firstName
    language
    lastName
    role {
      permissions
      roleName
      type
      invitableCompanyTypes
      id
      invitableCompanyTypes
    }
    roleId
    companyId
    notifications
    productTourStatus
    pushNotifications
    settings
    company {
      initialSetup
      name
      id
    }
  }
}`;
export const customGetContactPerson = /* GraphQL */ `
  query CustomGetContactPerson($id: ID!) {
    customGetContactPerson(id: $id) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
    }
  }
`;
